import { BootstrapIcon, getBootstrapIconUrl } from '../Global/icons'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const bellIcon = getBootstrapIconUrl(BootstrapIcon.Bell)

const t = document.createElement('template')
t.innerHTML = `
  <wa-icon 
    src="${bellIcon}" 
    class="header-icon" 
    label="Notifications"
    aria-label="Notifications"
    aria-hidden="false"
    focusable="true"
  ></wa-icon>
`

class NavHeaderUtilityBell extends HTMLElement {
  constructor() {
    super()
    tryLoadDependencies(document, [WebAwesomeComponent.Icon])
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityBell connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-utility-bell')) {
  customElements.define('ts-navheader-utility-bell', NavHeaderUtilityBell)
}
export { NavHeaderUtilityBell }
